import { getRequest, IDENTITY_PREFIX } from 'global/helpers/requests'
import type { Company } from './Company.types'

export const getUserCompanies = async (idToken: string): Promise<Company[]> =>
  await getRequest<Company[]>('authorizations/companies', { headers: { Authorization: `Bearer ${idToken}` } }, IDENTITY_PREFIX)
